export const ROUTE_PATH = '/clean/cleaner/inventory' as const
